module.exports = __webpack_public_path__ + "img/forms.533dc002.png";